/**
 * Placed point of the attacher to its origin.
 */
export enum CustomAttacherPositionToOrigin {
    topLeft = 'TopLeft',
    topRight = 'TopRight',
    bottomLeft = 'BottomLeft',
    bottomRight = 'BottomRight'
}
